import { SelectBox, Validator } from "devextreme-react";
import { RequiredRule } from "devextreme-react/validator";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { classifWorkData } from "./data";
import { updateClassifWork } from "./Redux/workRecord";

export default function ClassifWorkSelectBox(props) {
  // const { workRecord } = props;
  const {
    classifWorkSelectBoxRef,
    // currentEmployeeNo
    currentEmployee,
  } = props;

  // const workRecord = useSelector((state) => state.workRecord);
  const classifWork = useSelector((state) => state.workRecord.classifWork);
  const userInfo = useSelector((state) => state.userInfo);

  const dispatch = useDispatch();

  // const [dataSource, setDataSource] = useState(classifWorkData[userInfo.div]);

  const [dataSource, setDataSource] = useState(
    classifWorkData[currentEmployee.div]
  );

  // useEffect(() => {
  //   setDataSource(classifWorkData[userInfo.div]);
  // }, [userInfo]);
  useEffect(() => {
    setDataSource(classifWorkData[currentEmployee.div]);
  }, [currentEmployee]);

  const onValueChanged = (e) => {
    if (e.value) {
      classifWorkSelectBoxRef.current.instance.option(
        "validationStatus",
        "valid"
      );

      dispatch(
        updateClassifWork({
          classifWork: e.value,
          previousValue: e.previousValue,
        })
      );
    }
  };

  return (
    <SelectBox
      ref={classifWorkSelectBoxRef}
      // dataSource={classifWorkData[userInfo.div]}
      dataSource={dataSource}
      valueExpr="id"
      displayExpr={"name"}
      // showClearButton={true}
      value={classifWork}
      // disabled={userInfo.employeeNo == currentEmployeeNo ? false : true}
      // readOnly={userInfo.employeeNo == currentEmployeeNo ? false : true}
      readOnly={
        userInfo.employeeNo == currentEmployee.employeeNo ? false : true
      }
      onValueChanged={onValueChanged}
      // value={workRecord.classifWork}
    >
      {/* <Validator>
        <RequiredRule />
      </Validator> */}
    </SelectBox>
  );
}
